import { render, staticRenderFns } from "./CreateTable.vue?vue&type=template&id=25854c25&scoped=true"
import script from "./CreateTable.vue?vue&type=script&lang=js"
export * from "./CreateTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25854c25",
  null
  
)

export default component.exports